<template>
    <div class="section">
        <div class="center-section">
            <div class="form-heading">
                <h1 class="header-1">{{ $t('auth.verification.heading') }}</h1>
                <p class="caption">
                    {{ $t('auth.verification.description') }}
                </p>
            </div>

            <div class="resend-section">
                <p v-if="resendMessage" class="resend-message" :class="{ error: isError }">
                    {{ resendMessage }}
                </p>
                <primary-btn class="resend-btn" @click="handleResend" :disabled="isLoading">
                    {{ isLoading ? $t('auth.verification.sending') : $t('auth.verification.resend') }}
                </primary-btn>
            </div>

            <div class="login-link caption">
                <router-link to="/login" class="link">{{ $t('auth.reset.backToLogin') }}</router-link>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { authAPI } from '@/services/api';
import PrimaryBtn from '@/components/BaseComponents/PrimaryBtn.vue';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const email = route.query.email;
const isLoading = ref(false);
const resendMessage = ref('');
const isError = ref(false);
const { t } = useI18n();

async function handleResend() {
    if (!email) {
        resendMessage.value = t('auth.verification.emailNotFound');
        isError.value = true;
        return;
    }

    isLoading.value = true;
    resendMessage.value = '';
    isError.value = false;

    try {
        await authAPI.resendVerification(email);
        resendMessage.value = t('auth.verification.emailSent');
        isError.value = false;
    } catch (error) {
        console.error('Error resending verification:', error);
        resendMessage.value = t('auth.verification.failedToSend');
        isError.value = true;
    } finally {
        isLoading.value = false;
    }
}
</script>

<style scoped>
.center-section {
    width: 60%;
    margin: auto;
}

.form-heading {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: var(--spacing-xl);
}

.form-heading .caption {
    color: var(--color-white-40);
    text-align: center;
}

.form-heading img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

.signup-form {
    padding: var(--spacing-2xl);
    margin-bottom: var(--spacing-lg);
    background-color: var(--bg-card);
    border-radius: var(--border-radius-2xl);
}

.login-link {
    text-align: center;
    color: var(--color-white-40);
}

.link {
    color: var(--color-white);
    text-decoration: none;
}

.resend-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: var(--spacing-lg);
    text-align: center;
}

.resend-message {
    margin-bottom: var(--spacing-lg);
    font-size: var(--font-size-caption);
    color: var(--color-success);
}

.resend-btn {
    width: 50%;
}

.resend-message.error {
    color: var(--color-error-light);
}
</style>
